<!--
 * @Author: Terry
 * @Date: 2022-03-15 11:14:51
 * @LastEditors: Terry
 * @LastEditTime: 2022-04-19 17:03:33
 * @FilePath: /toutiao_01/src/views/home/index.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by ccde_terry@163.com, All Rights Reserved. 
-->
<template>
  <div class="container">
    <van-tabs animated swipeable v-model="activeIndex">
      <!-- 默认插槽 -->
      <van-tab :key="item.id" v-for="item in Channel" :title="item.name">
        <!-- 可滚动内容区域 默认插槽-->
        <ArticleList :channelId="item.id" />
      </van-tab>
    </van-tabs>

    <!-- <ChannelEdit
      v-model="isShows"
      :myChannel="Channel"
      :activeIndex="activeIndex"
      @enter-channel="activeIndex = $event"
    /> -->
  </div>
</template>
<script>
import { getChannelApi } from "../../api/channel";

import ArticleList from "./components/articleList.vue";
export default {
  name: "home-index",
  components: {
    ArticleList,
  },
  data() {
    return {
      Channel: [],
      isShowModal: false,
      isShows: false,
      activeIndex: 0,
     
    };
  },
  created() {
    this.getChannel();
   
  },
  watch: {
    channelId(oldVal,newVal){
      console.log(oldVal);
        console.log(newVal);
    },
    },
  methods: {
    async getChannel() {
      const { data } = await getChannelApi();
      this.Channel = data;
    }
  },
}
</script>

<style scoped lang='less'>
// 覆盖有赞页签组件的默认样式
.van-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  // 自定义tab样式=》/deep/覆盖子组件的样式
  /deep/ .van-tabs__wrap {
    height: 36px;
    padding-right: 36px;
    .van-tab {
      line-height: 36px;
    }
    .van-tabs__line {
      background-color: #fc6627;
      height: 2px;
    }
  }
  /deep/ .van-tabs__content {
    flex: 1;
    overflow: hidden;
  }
  /deep/ .van-tab__pane {
    height: 100%;
    // 控制列表区域可滚动
    .scroll-wrapper {
      height: 100%;
      overflow-y: auto;
    }
  }
}
.bar_btn {
  width: 36px;
  height: 35px;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  box-shadow: -6px -6px 8px #ddd;
}
</style>
